import { jsx as _jsx } from "react/jsx-runtime";
import { useBreakpoints } from '../../hooks/index.js';
import { KevelBanners } from '../../Shared/KevelBanners/KevelBanners.js';
import { MobilePrimaryKevelBanners } from './MobilePrimaryKevelBanners.js';
export const PrimaryKevelBanners = ({ kevelAds }) => {
    const { isMobile } = useBreakpoints();
    return isMobile ? (_jsx(MobilePrimaryKevelBanners, { kevelAds: kevelAds, ga4SubFeature: "primary_location" })) : (_jsx(KevelBanners, { hideOnMobile: true, kevelAds: kevelAds, ga4SubFeature: "primary_location" }));
};
//# sourceMappingURL=PrimaryKevelBanners.js.map